var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBackDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.51 1.87001L10.73 0.100006L0.839966 10L10.74 19.9L12.51 18.13L4.37997 10L12.51 1.87001Z",
    fill: "#A7AABD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackDark);
export default __webpack_public_path__ + "static/media/icon_back_dark.a91c43d61b72e71b7b20cac4fe72f48f.svg";
export { ForwardRef as ReactComponent };